import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_URL;
const instance = axios.create({
    //baseURL: 'https://configurador.monitoramentorural.com.br/api', // Set your base URL here
    baseURL: apiUrl,
    // Other global configuration options...
});

export default instance;
